import { httpRequest } from "@services/http";
import type { OpsFilters, OpsSummary } from "../opsDashboard.types";
import { applyFilters } from "./filterParams";

export class CommandGetOpsSummary {
    async run(filters: OpsFilters): Promise<OpsSummary> {
        const url = new URL(
            `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/analytics/ops-dashboard/summary`
        );
        applyFilters(url, filters);
        return await httpRequest<OpsSummary>(url.toString(), { method: "GET" });
    }
}
